import TextFieldsIcon from '@mui/icons-material/TextFields';
import PinIcon from '@mui/icons-material/Pin';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RepeatIcon from '@mui/icons-material/Repeat';

export const FIELD_CATEGORIES = [
  {
    label: 'Text & Numbers',
    types: [
      { value: 'text', label: 'Text', icon: TextFieldsIcon },
      { value: 'number', label: 'Number', icon: PinIcon },
      { value: 'rich_text', label: 'Rich Text', icon: FormatAlignLeftIcon },
    ],
  },
  {
    label: 'Date & Time',
    types: [
      { value: 'date', label: 'Date', icon: CalendarTodayIcon },
      { value: 'time', label: 'Time', icon: AccessTimeIcon },
    ],
  },
  {
    label: 'Selection',
    types: [
      { value: 'dropdown', label: 'Dropdown', icon: ArrowDropDownCircleIcon },
      { value: 'radio', label: 'Radio', icon: RadioButtonCheckedIcon },
      { value: 'checkbox', label: 'Checkbox', icon: CheckBoxIcon },
    ],
  },
  {
    label: 'Multi-item',
    types: [
      { value: 'list', label: 'List', icon: ListAltIcon },
    ],
  },
  {
    label: 'Layout',
    types: [
      { value: 'repeatable_section', label: 'Repeatable Section', icon: RepeatIcon },
    ],
  },
  {
    label: 'Other',
    types: [
      { value: 'display', label: 'Display (read-only)', icon: InfoOutlinedIcon },
      { value: 'file_upload', label: 'File Upload', icon: UploadFileIcon },
    ],
  },
];

export const ALL_TYPES = FIELD_CATEGORIES.flatMap((c) => c.types);

export function getTypeInfo(type) {
  return ALL_TYPES.find((t) => t.value === type);
}

export function makeDefaultField(type, order) {
  const base = {
    key: `${type}_${Date.now()}`,
    label: '',
    type,
    helpText: '',
    order,
  };

  if (type === 'display') {
    return { ...base, content: '', contentFormat: 'html' };
  }

  if (['dropdown', 'radio', 'checkbox'].includes(type)) {
    return {
      ...base,
      required: false,
      options: [{ value: 'option_1', label: 'Option 1' }],
    };
  }

  if (type === 'file_upload') {
    return {
      ...base,
      required: false,
      upload: { allowedMimeTypes: [] },
    };
  }

  if (type === 'repeatable_section') {
    return {
      ...base,
      children: [],
      minRepetitions: 1,
      maxRepetitions: null,
    };
  }

  if (type === 'list') {
    return {
      ...base,
      required: false,
      placeholder: '',
      listConfig: { minItems: null, maxItems: null },
    };
  }

  if (type === 'text') {
    return {
      ...base,
      required: false,
      placeholder: '',
      defaultValue: '',
      multiline: false,
    };
  }

  if (['number', 'date', 'time', 'rich_text'].includes(type)) {
    return {
      ...base,
      required: false,
      placeholder: '',
      defaultValue: '',
    };
  }

  return { ...base, required: false };
}
